<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-06-07 13:46:32
 * @LastEditors: lau
 * @LastEditTime: 2022-06-24 16:41:13
-->
<!-- 添加访客接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
 
        },
        responseCode: {
          "data": {
            "specialCarTypeId": 1
          }, "message": "业务成功", "resultCode": 0, "status": 1
        }, infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取特殊车辆类型列表",
          t_url: this.commonUrls.test + "getSpecialCarTypeList",
          p_url: this.commonUrls.prod + "getSpecialCarTypeList",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编号列表'},
              {info1: 'name', info2: '否', info3: 'String', info4: '特殊车辆类型名称'},
              {
                info1: 'vipGroupType',
                info2: '是',
                info3: 'Integer',
                info4: 'VIP组类型  1-访客VIP 2-黑名单VIP'
                // info4: 'VIP组类型  1-访客VIP 2-黑名单VIP，3预定vip'
              },
              {
                info1: 'pageSize',
                info2: '否',
                info3: 'Integer',
                info4: '每页多少条(默认10，最多1000)'
              },
              {
                info1: 'pageNum',
                info2: '否',
                info3: 'Integer',
                info4: '页码(默认1)'
              },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'id', info2: '是', info3: 'Long', info4: '特殊车辆类型id'},
              {info1: 'name', info2: '是', info3: 'Long', info4: '特殊车辆类型名称'},
              {info1: 'vipGroupType', info2: '是', info3: 'Long', info4: '特殊车辆类型(1访客,2黑名单)'},
              {info1: 'createTime', info2: '是', info3: 'Long', info4: 'yyyyMMddHHmmss'},
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
   /* @import "../../assets/less/conmon.less"; */
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getSpecialCarTypeList.vue